import React from 'react'
import { Dispatch } from 'redux'
import { CaptionLight, H2, H3, P } from '../../components/StyledText'
import { IMediaTypeGroup } from '../../types/mediaTypeGroup'
import { StyledPrioritiesTable } from './styled'
import { push } from '../../actions/router'

export interface IAllMediaTypeGroupsTab {
  mediaTypeGroupsList: IMediaTypeGroup[]
  dispatch: Dispatch
}

export const AllMediaTypeGroupsTab = ({
  mediaTypeGroupsList = [],
  dispatch,
}: IAllMediaTypeGroupsTab) => (
  <>
    <H2 ml={2}>Media type groups</H2>
    <StyledPrioritiesTable>
      <thead>
        <tr>
          <th>
            <CaptionLight>Title</CaptionLight>
          </th>
          <th>
            <CaptionLight>Description</CaptionLight>
          </th>
        </tr>
      </thead>
      <tbody>
        {mediaTypeGroupsList.map((mediaTypeGroup) => (
          <tr
            key={mediaTypeGroup.id}
            onClick={() =>
              dispatch(
                push(
                  `/settings/media-type-groups/${mediaTypeGroup.id}?tab=details`
                )
              )
            }
          >
            <td>
              <H3>{mediaTypeGroup.title}</H3>
            </td>
            <td>
              <P>{mediaTypeGroup.description}</P>
            </td>
          </tr>
        ))}
      </tbody>
    </StyledPrioritiesTable>
  </>
)
